module.exports = __webpack_public_path__ + "img/package2.def4ed43.png";